/* TAMA GEORGINA — Panier rapide taille sur les cartes .tama-card (accueil). Sans entrer sur la fiche. */
(function(){
  if(window.__tamaCardCart) return; window.__tamaCardCart=true;

  var CART_SVG='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>';
  var SIZE_RE=/^(taille|tailles|size|sizes|pointure|pointures|taglia|talla)$/i;
  var cache={};

  function getProd(h){ if(cache[h]) return cache[h]; cache[h]=fetch('/products/'+h+'.js',{credentials:'same-origin'}).then(function(r){return r.json();}); return cache[h]; }
  function handleOf(media){
    var card=media.closest('a[href*="/products/"]')||media.querySelector('a[href*="/products/"]');
    if(!card) return null;
    var h=card.getAttribute('href')||''; var i=h.indexOf('/products/');
    if(i<0) return null; h=h.slice(i+10);
    return h.split('?')[0].split('#')[0].split('/')[0]||null;
  }

  function build(media, prod){
    var wrap=document.createElement('div'); wrap.className='tama-qa';
    var toggle=document.createElement('button'); toggle.type='button'; toggle.className='tama-qa__toggle';
    toggle.setAttribute('aria-label','Choisir la taille et ajouter au panier'); toggle.innerHTML=CART_SVG;
    wrap.appendChild(toggle); media.appendChild(wrap);

    if(prod.variants.length===1){
      var v=prod.variants[0];
      if(v.available){ toggle.setAttribute('data-vid',v.id); toggle.setAttribute('data-single','1'); }
      else { toggle.classList.add('tama-qa__toggle--oos'); toggle.disabled=true; }
      return;
    }

    var panel=document.createElement('div'); panel.className='tama-qa-panel';
    var idx=-1;
    if(prod.options && prod.options.length){
      for(var i=0;i<prod.options.length;i++){
        var nm=(typeof prod.options[i]==='string')?prod.options[i]:(prod.options[i].name||'');
        if(SIZE_RE.test((nm||'').trim())){ idx=i; break; }
      }
    }
    if(idx>-1){
      var order=[], map={};
      prod.variants.forEach(function(v){
        var val=v.options[idx];
        if(!(val in map)){ map[val]={id:null,avail:false}; order.push(val); }
        if(v.available && !map[val].avail){ map[val].avail=true; map[val].id=v.id; }
      });
      order.forEach(function(val){
        var m=map[val];
        if(m.avail){ var b=document.createElement('button'); b.type='button'; b.className='tama-qa__size'; b.textContent=val; b.setAttribute('data-vid',m.id); panel.appendChild(b); }
        else { var s=document.createElement('span'); s.className='tama-qa__size tama-qa__size--oos'; s.textContent=val; panel.appendChild(s); }
      });
    } else {
      var shown=0;
      prod.variants.forEach(function(v){
        if(shown>=12) return;
        var b=document.createElement('button'); b.type='button';
        b.className='tama-qa__size'+(v.available?'':' tama-qa__size--oos');
        b.textContent=v.title;
        if(v.available) b.setAttribute('data-vid',v.id);
        panel.appendChild(b); shown++;
      });
    }
    media.appendChild(panel);
  }

  function inject(media){
    if(media.__qa) return; media.__qa=true;
    var handle=handleOf(media);
    if(!handle) return;
    getProd(handle).then(function(prod){
      if(prod && prod.variants && prod.variants.length) build(media, prod);
    }).catch(function(){});
  }

  var io=('IntersectionObserver' in window) ? new IntersectionObserver(function(es){
    es.forEach(function(en){ if(en.isIntersecting){ inject(en.target); io.unobserve(en.target); } });
  }, {rootMargin:'500px 0px'}) : null;

  function scan(){
    var boxes=document.querySelectorAll('.tama-card__media');
    if(io){ [].forEach.call(boxes, function(b){ if(!b.__qa) io.observe(b); }); }
    else { [].forEach.call(boxes, inject); }
  }

  ['pointerover','touchstart'].forEach(function(ev){
    document.addEventListener(ev, function(e){
      var m=e.target.closest && e.target.closest('.tama-card__media');
      if(m) inject(m);
    }, {passive:true});
  });

  function openDrawer(){
    var mc=document.querySelector('mini-cart');
    if(mc && typeof mc.getItems==='function'){ mc.getItems(); if(typeof mc.openModal==='function') mc.openModal(); }
    else { window.location.href='/cart'; }
  }
  function addVariant(id, btn, media){
    if(!id) return;
    if(btn) btn.classList.add('is-loading');
    fetch('/cart/add.js',{
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','X-Requested-With':'xmlhttprequest'},
      body: JSON.stringify({items:[{id:id, quantity:1}]})
    })
    .then(function(r){ if(!r.ok) throw 0; return r.json(); })
    .then(function(){
      if(btn) btn.classList.remove('is-loading');
      var tog=media ? media.querySelector('.tama-qa__toggle') : null;
      if(tog){ tog.classList.add('is-added'); setTimeout(function(){ tog.classList.remove('is-added'); }, 1300); }
      openDrawer();
    })
    .catch(function(){ if(btn) btn.classList.remove('is-loading'); window.location.href='/cart'; });
  }

  document.addEventListener('click', function(e){
    var toggle=e.target.closest('.tama-qa__toggle');
    if(toggle){
      e.preventDefault(); e.stopPropagation();
      if(toggle.disabled) return;
      var media=toggle.closest('.tama-card__media');
      if(toggle.getAttribute('data-single')){ addVariant(toggle.getAttribute('data-vid'), toggle, media); return; }
      var wasOpen=media.classList.contains('tama-qa-open');
      [].forEach.call(document.querySelectorAll('.tama-card__media.tama-qa-open'), function(o){ o.classList.remove('tama-qa-open'); });
      if(!wasOpen) media.classList.add('tama-qa-open');
      return;
    }
    var sizeEl=e.target.closest('.tama-qa__size');
    if(sizeEl){
      e.preventDefault(); e.stopPropagation();
      if(sizeEl.classList.contains('tama-qa__size--oos') || !sizeEl.getAttribute('data-vid')) return;
      var media2=sizeEl.closest('.tama-card__media');
      addVariant(sizeEl.getAttribute('data-vid'), sizeEl, media2);
      if(media2) media2.classList.remove('tama-qa-open');
      return;
    }
    if(!e.target.closest('.tama-qa-panel') && !e.target.closest('.tama-qa')){
      [].forEach.call(document.querySelectorAll('.tama-card__media.tama-qa-open'), function(o){ o.classList.remove('tama-qa-open'); });
    }
  }, true);

  function init(){ scan(); }
  if(document.readyState!=='loading') init(); else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', scan);
  if(window.MutationObserver){
    var t; new MutationObserver(function(){ clearTimeout(t); t=setTimeout(scan,200); }).observe(document.body, {childList:true, subtree:true});
  }
})();
